module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/1mill-inactive-32f2d2ddf6d0568f80f6160416f908d5.png";